module.exports = __webpack_public_path__ + "img/d65c82c.jpg";